import * as actionTypes from 'actions/actionTypes';
import { call, put, takeEvery } from 'redux-saga/effects';
import { getCustomFieldGroups } from 'api/customFieldGroups';
import { addNotification } from 'actions/notificationActions';

import { customFieldGroupsActions } from '../actions/customFieldGroupsActions';

import accessDeniedHandler from './handlers/accessDeniedHandler';

import { monitoring } from '../monitoring';

const defaultMessage = 'Something went wrong... cannot load custom fields groups for you';

function* customFieldGroupsRequest(action) {
    try {
        const customFieldsResponse = yield call(getCustomFieldGroups, action.payload.type);
        yield put(customFieldGroupsActions.success(customFieldsResponse, action.payload.type));
    } catch (error) {
        monitoring.captureException(error);
        yield put(
            addNotification({
                message: accessDeniedHandler(error, defaultMessage),
                type: 'danger',
            })
        );
    }
}
export default function* customFieldGroupsWatcher() {
    yield takeEvery(actionTypes.GET_CUSTOM_FIELD_GROUPS['REQUEST'], customFieldGroupsRequest);
}
